<template>
  <div class="tabs-header tabs-common ">
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Transport Financial</label> -->
      <div class="col-sm-10">
        <div class="select-wrapper">
          <select v-model="tab_data.form_type" id="form-type" class="form-control" onchange=" this.dataset.chosen = this.value; " :data-chosen="tab_data.form_type">
            <option value="" disabled>Form Type</option>
            <option value="form_m">Form M</option>
          </select>
          <label for="form-type">Form Type</label>
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label bolder_label">Application Number</label> -->
      <div class="col-sm-10">
        <input type="text" id="app-number" class="form-control" v-model="tab_data.form_m_number" placeholder="Application Number">
        <label for="app-number">Application Number</label>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-sm-10">
        <div class="select-wrapper">
          <select v-model="tab_data.valid_forex" id="valid-forex" class="form-control" onchange=" this.dataset.chosen = this.value; " data-chosen="">
            <option value="" disabled selected>Valid for FOREX (Y/N)</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
          <label for="valid-forex">Valid for FOREX (Y/N)</label>
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label bolder_label">Valid until</label> -->
      <div class="col-sm-10">
        <NewDatepickerWrapper
          v-model="tab_data.valid_until"
          type="date"
          id="valid-until"
          placeholder="Valid until">
        </NewDatepickerWrapper>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label bolder_label">Prefix</label> -->
      <div class="col-sm-10">
        <div class="select-wrapper">
          <select v-model="tab_data.form_m_prefix" id="form-m-prefix" class="form-control" onchange=" this.dataset.chosen = this.value; " :data-chosen="tab_data.form_m_prefix">
            <option value="" disabled>Prefix</option>
            <option value="BA">BA</option>
            <option value="CB">CB</option>
          </select>
          <label for="form-m-prefix">Prefix</label>
        </div>
      </div>
    </div>
    <p class="common-title">Applicant’s Banker (Authorized Dealer)</p>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label bolder_label">Applicant’s Banker (Authorized Dealer)</label> -->
      <div class="col-sm-4">
        <input type="text" class="form-control" id="adbankname" v-model="tab_data.adb_name" style="width: 100% !important;" placeholder="AD’s Bank Name">
        <label for="adbankname">AD’s Bank Name</label>
      </div>
      <!-- <label class="col-sm-2 col-form-label">AD’s Bank Code</label> -->
      <div class="col-sm-4">
        <input type="text" class="form-control" id="adbankcode" v-model="tab_data.ad_bank_code" style="width: 100% !important;" placeholder="AD’s Bank Code">
        <label for="adbankcode">AD’s Bank Code</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">AD’s Adress</label> -->
      <div class="col-sm-4">
        <NewSelectWrapper type="country" v-model="tab_data.ad_bank_address" style="width: 100% !important" placeholder="AD’s Address"/>
      </div>
      <!-- <label class="col-sm-2 col-form-label">Bank Branch</label> -->
      <div class="col-sm-4">
        <input type="text" class="form-control" id="bankbranch" v-model="tab_data.ad_branch" style="width: 100% !important;" placeholder="Bank Branch">
        <label for="bankbranch">Bank Branch</label>
      </div>
    </div>
    <!-- <div class="foot_pagination">
      <img src="@/assets/chevron_left24.png" alt="" v-if="cur_tab_name!='Header'" @click="page_change('',-1)">
      {{ cur_tab_name }}
      <img src="@/assets/chevron_right24.png" alt="" v-if="cur_tab_name!='Support Information'"
           @click="page_change('Names&Parties',1)">
    </div> -->
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";
import NewSelectWrapper from './../../fields/NewSelectWrapper.vue'
import NewDatepickerWrapper from './../../fields/NewDatepickerWrapper.vue'

export default {
  name: 'tabs-header',
  components: {NewSelectWrapper, NewDatepickerWrapper},
  props: ['cur_tab_name', 'indata'],
  mixins: [common],
  data() {
    return {
      tab_data: {
        form_type: '',
        form_m_number: 'MF',
        form_m_prefix: '',
        valid_forex: '',
        adb_name: '',
        ad_bank_code: 0,
        ad_bank_address: '',
        ad_branch: '',
      }
    }
  },
  methods: {
    /**
     * loads an incrementing sequence number from backend, is hardcoded at the moment.
     */
    getIncrementingSequence(){
      return '000000001';
    }
  },
  mounted(){
    const year = new Date().getFullYear()
    this.tab_data.form_m_number = 'MF'+year+this.getIncrementingSequence()
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tabs-header{
  border-radius: 0 20px 20px 20px;
}
</style>
